import './save-rule-modal.scss';
import CustomIcon, { IconType } from '../../../../shared/custom-icon/custom-icon';
import { ComponentLinkDetails, FieldMessage, TabsErrors } from '../../../../../dtos/error-message.dto';
import { Link } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../../store';

interface SaveRuleModalProps {
    ruleErrors: TabsErrors;
    isRuleValid: boolean;
}

export const SaveRuleModal: React.FC<SaveRuleModalProps> = observer(({ ruleErrors, isRuleValid }) => {
    const { fwVersionStore, customerStore } = useStores();

    const sectionHeader = (title: string, isNotValid: boolean) => {
        return <div className={`section-title ${isNotValid ? 'is-not-valid' : 'is-valid'}`}>
            <CustomIcon type={isNotValid ? IconType.RED_ERROR : IconType.GREEN_CHECK} />
            {title}
        </div>;
    };
    
    const createLinkComponent = (componentLinkDetails?: ComponentLinkDetails) => {
        const { selectedCustomer, serviceId } = customerStore;
        if (!componentLinkDetails || !selectedCustomer) return null;

        return <Link className="exceptions-link-wrapper"
            to={`/${selectedCustomer.customerId}/${serviceId}/protection/version/${fwVersionStore.selectedVersionId}/${componentLinkDetails.url}`}>
            <div className="link">{componentLinkDetails.text}</div>
        </Link>;
    };

    const renderSection = (section: string, fields: FieldMessage[]) => {
        return <div key={section} className={`section-wrapper ${section.toLowerCase().replaceAll(' ', '-')}`}>
            {sectionHeader(section, fields.some(field => !field.isValid))}
            <ul className={'section-details'}>
                {fields.map(field =>
                    <li key={field.fieldName} className={`${field.fieldName} ${field.isValid ? 'is-valid' : 'is-not-valid'}`}>
                        {field.message}
                        {createLinkComponent(field.componentLinkDetails)}
                    </li>
                )}
            </ul>
        </div>;
    };

    return <>
        {!isRuleValid && <div className={'rule-not-valid-explain'}>To save rule, complete the missing data and try again.</div>}
        <div className={'rule-summary-sub-title'}>Rule summary:</div>
        {Object.keys(ruleErrors).map((section: string) => renderSection(section, ruleErrors[section]))}
    </>;
});